import { connect } from 'react-redux';
import { forgotPassword } from 'redux/modules/forgot-password/actions/forgot-password';
import { resetEmail } from 'redux/modules/forgot-password/actions/reset-email';
import { getEmail } from 'redux/modules/forgot-password/selectors';
import ForgotPassword from './ForgotPassword';

export default connect(
  state => ({
    email: getEmail(state),
  }),
  {
    onSubmit: forgotPassword,
    onUnloadSuccess: resetEmail,
  },
)(ForgotPassword);
